import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/AuthContext";

/**
 * Renders for unauthorized users (unregistered, deactivated, etc.)
 * Displays the error message from the authentication API response
 *
 * This component is shown when:
 * - User is not found in the system (unregistered)
 * - User account is deactivated
 * - User account is inactive
 * - Any other unauthorized error from the exchange API
 */
function Unauthorized() {
  const { t } = useTranslation();
  const { logout, unauthorizedError } = useAuth();

  // Get error message from context
  const errorMessage =
    unauthorizedError?.message || t("Errors.UnauthorizedUserMessage");
  const errorType = unauthorizedError?.type || "unauthorized";

  // Set page title based on error type
  useEffect(() => {
    if (errorType === "deactivated") {
      document.title = t("app.DeactivatedUser");
    } else if (errorType === "inactive") {
      document.title = t("app.InactivatedUser");
    } else if (errorType === "unregistered") {
      document.title = t("app.UnregisteredUser");
    } else {
      document.title = t("app.UnauthorizedUser");
    }
  }, [errorType, t]);

  // Handle logout/go back button click
  const onNavigate = () => {
    logout();
  };

  return (
    <div className='section-background-image' style={{ height: "100vh" }}>
      <div className='section-bg-content'>
        <div className='content'>{errorMessage}</div>

        <div className='button-group'>
          <button className={"btn app-btn-secondary"} onClick={onNavigate}>
            {t("Common.Logout")}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Unauthorized;
